import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth, apiError } from "@/context/AuthContext";
import { toast } from "sonner";
import { Sparkles } from "lucide-react";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const u = await login(email, password);
      toast.success("Bem-vinda de volta!");
      nav(u.role === "platform_admin" ? "/admin" : (u.onboarding_completed ? "/app" : "/onboarding"));
    } catch (err) {
      toast.error(apiError(err, "Não foi possível entrar."));
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-4 py-10 grain">
      <div className="w-full max-w-md">
        <div className="mb-8">
          <div className="flex items-center gap-2 mb-2">
            <div className="w-9 h-9 rounded-xl bg-[#682F3E] flex items-center justify-center">
              <Sparkles size={18} className="text-[#EBD8D2]" strokeWidth={1.8} />
            </div>
            <span className="font-display text-xl font-bold text-[#27272A]">NailControl</span>
          </div>
          <h1 className="font-display text-3xl font-bold text-[#27272A]">Entrar</h1>
          <p className="text-[#71717A] text-sm mt-1">Seu preço, sua agenda e seu negócio sob controle.</p>
        </div>

        <form onSubmit={onSubmit} className="card-nc p-6 space-y-4" data-testid="login-form">
          <div>
            <label className="block text-xs font-semibold uppercase tracking-wide text-[#71717A] mb-1.5">E-mail</label>
            <input data-testid="login-email"
              type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
              className="w-full h-12 px-3 rounded-xl border border-[#E4E4E7] focus:border-[#682F3E] focus:ring-2 focus:ring-[#682F3E]/10 outline-none transition" />
          </div>
          <div>
            <label className="block text-xs font-semibold uppercase tracking-wide text-[#71717A] mb-1.5">Senha</label>
            <input data-testid="login-password"
              type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
              className="w-full h-12 px-3 rounded-xl border border-[#E4E4E7] focus:border-[#682F3E] focus:ring-2 focus:ring-[#682F3E]/10 outline-none transition" />
          </div>
          <button data-testid="login-submit" disabled={loading} className="btn-primary-nc w-full">
            {loading ? "Entrando…" : "Entrar"}
          </button>
          <div className="text-center text-sm text-[#71717A]">
            Ainda não tem conta?{" "}
            <Link data-testid="link-register" to="/register" className="text-[#682F3E] font-semibold hover:underline">Criar conta</Link>
          </div>
        </form>
      </div>
    </div>
  );
}
